/* eslint-disable no-continue */
import { isValidRegex } from '../../MenuBar/MenuBarModals/ValidateAndSaveVersionModals/validateRegex';
import type { IsolatedEditingBlockOrigin } from '../../NodeEditorDrawer/types';
import { ThresholdRightAttributeOrigin } from '../../NodeEditorDrawer/types';
import { listDelineators } from './constants';

export const isValidIntegerList = (str: string) => {
  for (const char of str) {
    if (listDelineators.has(char)) continue;
    if (isNaN(parseFloat(char))) return false;
  }
  return true;
};

export const isValidDecimalList = (str: string) => {
  for (const char of str) {
    if (listDelineators.has(char)) continue;
    if (char === '.') continue;
    if (isNaN(parseFloat(char))) return false;
  }
  return true;
};

export const selectValidator = (
  mode: IsolatedEditingBlockOrigin, dataType: string,
) => {
  if (mode === ThresholdRightAttributeOrigin.THRESHOLD_RIGHT_ATTRIBUTE_VALUE_REGEX) {
    return isValidRegex;
  }
  // only other possible options at the moment are list inclusion
  if (dataType === 'decimal') return isValidDecimalList;

  return isValidIntegerList;
};
